import loadable from '@loadable/component';

const HostAndCreators = loadable(() => import('./HostsAndCreators'));

export default HostAndCreators;
